import { request } from "./client";
import type {
  Asset,
  AssetUploadInitiation,
  Creative,
  CreativeAssignment,
  CreativeAssignmentCreateCommand,
  CreativeCreateCommand,
  CreativePublication,
  CreativeVersion,
  CreativeVersionCreateCommand,
} from "./types";

const base = "/admin/v1/creatives";

export const creatives = {
  list: () => request<Creative[]>(base),
  get: (id: string) => request<Creative>(`${base}/${id}`),
  create: (command: CreativeCreateCommand) => request<Creative>(base, { method: "POST", body: command, csrf: true }),
  createVersion: (id: string, command: CreativeVersionCreateCommand) =>
    request<CreativeVersion>(`${base}/${id}/versions`, { method: "POST", body: command, csrf: true }),
  getVersion: (id: string, versionId: string) => request<CreativeVersion>(`${base}/${id}/versions/${versionId}`),
  publish: (id: string, versionId: string) =>
    request<CreativePublication>(`${base}/${id}/versions/${versionId}/publish`, { method: "POST", csrf: true }),
  assign: (command: CreativeAssignmentCreateCommand) =>
    request<CreativeAssignment>(`${base}/assignments`, { method: "POST", body: command, csrf: true }),
};

export const assets = {
  listReady: (advertiserId: string) =>
    request<Asset[]>(`/admin/v1/advertisers/${advertiserId}/assets?status=ready&assetRole=original`),
  initiate: (advertiserId: string, file: File) =>
    request<AssetUploadInitiation>(`/admin/v1/advertisers/${advertiserId}/asset-uploads`, {
      method: "POST", body: { mimeType: file.type, byteSize: file.size }, csrf: true,
    }),
  put: async (upload: AssetUploadInitiation, file: File): Promise<void> => {
    const response = await fetch(upload.uploadUrl, {
      method: "PUT",
      headers: { "Content-Type": upload.mimeType },
      body: file,
    });
    if (!response.ok) throw new Error(`object_store_${response.status}`);
  },
  complete: (advertiserId: string, uploadId: string) =>
    request<Asset>(`/admin/v1/advertisers/${advertiserId}/asset-uploads/${uploadId}/complete`, { method: "POST", csrf: true }),
  upload: async (advertiserId: string, file: File): Promise<Asset> => {
    const initiation = await assets.initiate(advertiserId, file);
    await assets.put(initiation, file);
    return assets.complete(advertiserId, initiation.uploadId);
  },
};
